import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';

// rehype-highlight's default language set (lowlight `common`) is already
// tree-shaken and measured smaller than a hand-picked list of imports from
// highlight.js/lib/languages/*, which drags in the un-shaken core. Leave it.
const remarkPlugins = [remarkGfm];
const rehypePlugins = [[rehypeHighlight, { detect: true, ignoreMissing: true }]] as never;

const components = {
  a: ({ node: _node, ...props }: { node?: unknown } & React.ComponentProps<'a'>) => (
    <a {...props} target="_blank" rel="noreferrer noopener" />
  ),
};

/**
 * Memoised because a streaming turn re-renders the transcript on every frame
 * and re-parsing settled markdown blocks dominates the profile otherwise.
 */
export const Markdown = memo(function Markdown({ children }: { children: string }) {
  return (
    <div className="md">
      <ReactMarkdown
        remarkPlugins={remarkPlugins}
        rehypePlugins={rehypePlugins}
        components={components}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
});
